// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__lh9VQ","overlayStyles":"styles_overlayStyles__5_GBX","modalStyles":"styles_modalStyles__1nzO_","buttonStyles":"styles_buttonStyles__4rhfu"};